module.exports = __webpack_public_path__ + "img/filter.50ca8cf7.svg";